'use strict';

var $ = require('jquery');

module.exports = function (options) {
  var context = options.context;

  function init() {
    if (context.find('[data-binding="podcast-year-toggle"]').length > 1) {
      context.find('[data-binding="podcast-year-toggle"]').on('click', function () {
        var selectedVariation = $(this);
        context.find('[data-binding="podcast-year-toggle"]').each(function () {
          var currentVariation = $(this);
          if (selectedVariation.is(currentVariation)) {
            currentVariation.parent().toggleClass('closed');
          } else {
            currentVariation.parent().addClass('closed');
          }
        });
      });

      context.find('[data-binding="podcast-year"]:not(:first)').addClass('closed');
    }
  }

  return {
    init: init
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/podcast.js
// module id = 507
// module chunks = 0